import axios from '../utils/axiosClient';
import endpoints from './endpoints';

const {
  createNewPayment,
  createRecurringPayment,
  getStandingOrders,
  editRemoveStandingOrder,
  createNewNraPayment,
  getPaymentDetails,
  recentPayments,
  validateNewNRAPayment,
  confirmNRAPayment,
} = endpoints;

const createPayment = async (data: any, idempotencyKey: string) => {
  try {
    const headers: Record<string, string> = { 'X-Idempotency-Key': idempotencyKey };
    if (data instanceof FormData) headers['Content-Type'] = 'multipart/form-data';
    const response = await axios.post(createNewPayment, data, { headers });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const fetchPayment = async (id: string) => {
  try {
    const response = await axios.get(getPaymentDetails(id));
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const createRecPayment = async (data: any, idempotencyKey: string) => {
  try {
    const headers: Record<string, string> = { 'X-Idempotency-Key': idempotencyKey };
    if (data instanceof FormData) headers['Content-Type'] = 'multipart/form-data';
    const response = await axios.post(createRecurringPayment, data, { headers });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const loadStandingOrders = async (params: any) => {
  try {
    const response = await axios.get(getStandingOrders, { params });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const removeStandingOrder = async (id: string) => {
  try {
    const response = await axios.delete(editRemoveStandingOrder(id));
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const createNraPayment = async (data: any) => {
  try {
    const response = await axios.post(createNewNraPayment, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const getRecentPayments = async () => {
  try {
    const response = await axios.get(recentPayments);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const validateNRAPayment = async (data: any) => {
  try {
    const response = await axios.post(validateNewNRAPayment, data);
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const confirmNewNRAPayment = async (data: any, idempotencyKey: string) => {
  try {
    const response = await axios.post(confirmNRAPayment, data, { headers: { 'X-Idempotency-Key': idempotencyKey } });
    return response.data;
  } catch (error: any) {
    return Promise.reject(error.response);
  }
};

const paymentsServices = {
  createPayment,
  createRecPayment,
  loadStandingOrders,
  removeStandingOrder,
  createNraPayment,
  fetchPayment,
  getRecentPayments,
  validateNRAPayment,
  confirmNewNRAPayment,
};

export default paymentsServices;
